<!-- MainLayout with Shell Switching - Feature: 012-desktop-mobile-shells -->
@switch (shell$ | async) {
  @case ('desktop') {
    <app-desktop-shell>
      <router-outlet></router-outlet>
    </app-desktop-shell>
  }
  @case ('mobile') {
    <app-mobile-shell>
      <router-outlet></router-outlet>
    </app-mobile-shell>
  }
  @default {
    <!-- Fallback to desktop shell while loading -->
    <app-desktop-shell>
      <router-outlet></router-outlet>
    </app-desktop-shell>
  }
}